import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CMSProvider } from '@/context/CMSContext';
import { AdminAuthProvider } from '@/context/AdminAuthContext';
import MainLayout from '@/layouts/MainLayout';
import AdminLayout from '@/layouts/AdminLayout';
import Home from '@/pages/Home';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Services from '@/pages/Services';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminProjects from '@/pages/admin/Projects';
import ProjectFormPage from '@/pages/admin/ProjectForm';
import AdminMessages from '@/pages/admin/Messages';
import AdminEmail from '@/pages/admin/Email';
import AdminSecurity from '@/pages/admin/Security';
import AdminReviews from '@/pages/admin/Reviews';
import AdminUsers from '@/pages/admin/Users';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <CMSProvider>
      <AdminAuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Main Site Routes */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
              <Route path="/admin/projects/new" element={<ProjectFormPage />} />
              <Route path="/admin/projects/edit/:id" element={<ProjectFormPage />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/reviews" element={<AdminReviews />} />
              <Route path="/admin/email" element={<AdminEmail />} />
              <Route path="/admin/security" element={<AdminSecurity />} />
              <Route path="/admin/users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </Router>
      </AdminAuthProvider>
    </CMSProvider>
  );
}

export default App;
